module.exports = __webpack_public_path__ + "img/f6-1.c84e6e9a.png";